<template>
  <li>
    <v-card elevation="0" 
            outlined class="card-funcionario"
            v-on:click = "funcionario.selecionado = !funcionario.selecionado"
            :class="funcionario.selecionado ? 'card-borda' : ''"
      ><p>{{ funcionario.login }}</p></v-card
    >
  </li>
</template>
<script>
import Funcionario from '@/model/funcionario/Funcionario';
export default {
  props: {
    funcionario: {
      type: Object,
      default: () => (new Funcionario()),
    },
  },
  methods: {
    selecionarFuncioanario(funcionario) {
        funcionario.selecionado = !funcionario.selecionado;
    }
  }
};
</script>
<style lang="scss" scoped>
.card-funcionario {
  padding: 10px;
  border-radius: 3px;
  margin: 5px;
  cursor: grab;
}
.card-borda {
  border-color: dodgerblue;
}
li {
  list-style: none;
}
</style>